import React from "react";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../../components/header/HeaderDefault";
import CopyRight from "../../../components/footer/copyright/CopyRight";
import Footer from "../../../components/footer/Footer";
import ServiceList from "../../../components/list/ServiceList";
import ServiceFaq from "../../../components/faq/ServiceFaq";
import Skills from "../../../components/skill/Skills";
import AppServiceApproach from "../../../components/service/AppServiceApproach";
import CounterThree from "../../../components/counter/CounterThree";
import ImageGridOne from "../../../components/image-grid/ImageGridOne";
import AppDevelopmentProcess from "../../../components/service/AppDevelopmentProcess";


const AppService = () => {
    return (
        <div>
            <Helmet>
                <title>Multi Cloud Ai - App Devlopment</title>
            </Helmet>
            {/* End Page SEO Content */}

            <HeaderDefault />
            {/* End Header */}

            <div className="ptf-main">
                <div className="ptf-page ptf-page--service-detail">
                    <section>

                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-9">
                                    {/* <!--Animated Block--> */}

                                </div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <h1 className="large-heading2 text-center"
                                    >Mobile App Development With Multi Cloud Ai
                                    </h1>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        Building mobile applications require analytical skills,
                                        high creativity and technical knowledge. We pursue a step
                                        by step approach in designing mobile applications that
                                        includes Research, Backened, Platform,User Interface and
                                        User Experience, Clean Coding, QA Performance and Testing
                                        Skills and Analytics. We possess highly skilled app developers
                                        who are updated with the latest technology trends. </p>

                                    <ImageGridOne />

                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>A Leading Company</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        Multi Cloud Ai is one of the leading mobile app development companies
                                        in India specializing in building responsive applications for
                                        mobile, desktop and tablets. We are  the pioneers  among the
                                        excellent mobile app development companies in India and render
                                        trustworthy digital services to enterprises and startups. Multi Cloud Ai
                                        comprises experienced engineers who develop a large range of
                                        mobile applications across the globe. Our expertise within the
                                        area of app development can raise your  business to touch heights.
                                        More broadly, we pay vigilant attention to each and every aspect
                                        of mobile app development, utilizing cutting edge technologies to
                                        create robust mobile applications.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Top Portion */}

                    {/* <!--Spacer--> */}
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "6rem" }}
                    ></div>


                    <div
                        className="ptf-animated-block"
                        data-aos="fade"
                        data-aos-delay="0"
                    >
                        <h4 style={{ marginLeft: "20px" }}>
                            Mobile Apps Development Solutions We Provide</h4>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "1.5rem" }}
                        ></div>
                        <div className="fz-18 my_background" style={{ marginLeft: "20px" }}>
                            <ul>
                                <li>App development integrated with backend ERP solutions</li>
                                <li>E-commerce mobile application development</li>
                                <li>Custom mobile product development and testing</li>
                                <li>Business Consulting and Strategy Solutions</li>
                                <li>Healthcare and Cleaning Application</li>
                                <li>File sharing systems</li>
                                <li>GPS enabled application development</li>
                                <li>Inventory tracking and verification application</li>
                                <li>Educational and online e- learning application</li>
                            </ul>
                        </div>
                    </div>
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                    ></div>
                    <section
                        className="has-accent-1-background"
                        style={{
                            backgroundImage: `url("assets/img/root/service-bubble.png")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "100% calc(100% + 120px)",
                        }}
                    >
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                        ></div>
                        <div className="container-xxl">
                            {/* <!--Animated Block--> */}
                            <div
                                className="ptf-animated-block"
                                data-aos="fade"
                                data-aos-delay="1"
                            >
                                <h1 className="has-white-color large-heading">Experties in App Development</h1>
                            </div>
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "7.5rem", "--ptf-md": " 3.75rem" }}
                            ></div>
                            <AppServiceApproach />
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
                        ></div>
                    </section>

                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5.625rem", "--ptf-md": "2.8125rem" }}
                        ></div>
                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-8">
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Technology We Use</h2>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Cross Platform Application</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Cross-platform development  specifically used to build and
                                            publish apps that can run across multiple device platforms,
                                            such as iOS, Android, and the Universal Windows Platform.
                                            With tremendous changing technology requirements, cross-platform
                                            app development has emerged as a source of rendering consistent
                                            user experience on any device or platform employees use. VB Easy
                                            experts creates software, applications, or services that can be
                                            operative on more than one platform or operating system. Mainly,
                                            one of the greatest advantages attributed to Cross-platform app
                                            development is app developers are able to reuse codes similar
                                            across all platforms.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Android Mobile and iOS Apps</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background ">
                                            With rapidly growing stipulation of Android Apps globally, our
                                            phenomenal experts help clients to match their product with the
                                            right characteristics for the right audience attributed with
                                            vigorous  strategies, design, development, latest technologies,
                                            launching and many more. VB Easy have years of  experience developing
                                            iOS applications which are recently ruling the app store. We design
                                            and create  robust  app solutions for the whole iOS platform by immense
                                            integration of the seamless experiences in close harmony with the
                                            platform to help you give reliability to your business.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>React Native</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            With React Native, We not only create mobile & web applications, an
                                            HTML5 App or a hybrid app, but also constitute a real-time mobile
                                            application that's indiscernible from an app created  using Objective-C
                                            or Java. At VB Easy, we deliver react native apps that ensure speed and
                                            agility for the mobile apps with responsiveness and a tremendous native
                                            app based user experience.
                                            {/* <!--Spacer--> */}
                                            <div
                                                className="ptf-spacer"
                                                style={{ "--ptf-xxl": "0.5rem" }}
                                            ></div>
                                            Mainly, react native helps in creating cross
                                            platform apps also it saves a lot of time and cost to develop mobile
                                            apps on multiple platforms.
                                        </p>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Flutter App Development</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Flutter is an agile and the most reactive tool that permits the
                                            creating  and deployment of UI with robust animations and a single
                                            codebase that operates on  both iOS and Android platforms. This
                                            indistinguishable and extremely reliable mobile UI framework enables
                                            us to produce high-quality native interfaces on cross platforms just
                                            within a 120 FPS record time. We emphasize focus on eye catching UI,
                                            Support and maintenance, accessibility SDKs and advanced app development
                                            approach. Our phenomenal app developers are our pride and they possess
                                            expertise  in developing apps by Flutter.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.125rem" }}
                                    ></div>
                                    <div
                                        className="row"
                                        style={{
                                            "--bs-gutter-x": "3.75rem",
                                            "--bs-gutter-y": "7.5rem",
                                        }}
                                    >
                                        <CounterThree />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h3>Our Skills</h3>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.75rem" }}
                                    ></div>
                                    <div className="ptf-skill-box-grid">
                                        <Skills />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Our App Development Process</h2>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>

                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5.625rem" }}
                                    ></div>
                                    {/* <!--Process Steps--> */}
                                    <AppDevelopmentProcess />
                                </div>
                                <div className="col-xl-4">
                                    <div className="ptf-sidebar ptf-sidebar--right">
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-services-list">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">Services List</h4>
                                                <ServiceList />
                                            </div>
                                        </div>
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-faq">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">FAQs</h4>
                                                <ServiceFaq />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
                        ></div>
                    </section>
                    {/* End .main content with sidebar */}
                </div>
                {/* End .ptf-page */}
            </div>
            {/* End ptf-main */}

            {/*=============================================
              Start Footer
              ============================================== */}
            <footer className="ptf-footer ptf-footer--style-1">
                <div className="container-xxl">
                    <div className="ptf-footer__top">
                        <Footer />
                    </div>
                    <div className="ptf-footer__bottom">
                        <CopyRight />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default AppService;
